export var OfflineDisabled = null;
//# sourceMappingURL=offline.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amplitude/analytics-types/lib/esm/offline.js
// module id = 717
// module chunks = 1